import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from "./ui/dropdown-menu";
import { Button } from "./ui/button";
import { FilterIcon } from "lucide-react";
import { DropdownMenuSeparator } from "@radix-ui/react-dropdown-menu";

export default function FilterDropDownButton({ items, onReset }) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button className="px-2">
          <FilterIcon className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-[250px]">
        {items.map((item, index) => (
          <DropdownMenuItem
            key={index}
            className="focus:bg-transparent block"
            asChild
            onSelect={(e) => e.preventDefault()}
          >
            <div
              // onPointerDown={(e) => e.stopPropagation()}
              // onClick={(e) => e.preventDefault()}
            >
              {item}
            </div>
          </DropdownMenuItem>
        ))}
        {items.length > 0 && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem
              onClick={(e) => {
                e.preventDefault();
                onReset?.();
              }}
              className="text-red-500 focus:bg-destructive/10"
            >
              Reset
            </DropdownMenuItem>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
